import { z } from "zod";
import { idSchema } from "./shared";

export const devLoginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});

export const sessionUserSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  email: z.string().email(),
  name: z.string().min(1),
  role: z.enum(["admin", "member"]),
});

export type SessionUserDto = z.infer<typeof sessionUserSchema>;

export const authMeResponseSchema = z.object({
  user: sessionUserSchema.nullable(),
});

export const authConfigResponseSchema = z.object({
  authMode: z.enum(["dev", "google"]),
  googleEnabled: z.boolean(),
});

export const authSessionResponseSchema = z.object({
  user: sessionUserSchema,
});

export const apiKeySchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  userId: idSchema,
  name: z.string().min(1),
  prefix: z.string().min(1),
  createdAt: z.string().min(1),
  lastUsedAt: z.string().min(1).nullable(),
  revokedAt: z.string().min(1).nullable(),
});

export const apiKeyListResponseSchema = z.object({
  items: z.array(apiKeySchema),
});

export const createApiKeyRequestSchema = z.object({
  name: z.string().min(1).max(80),
});

export const createApiKeyResponseSchema = z.object({
  apiKey: apiKeySchema,
  token: z.string().min(1),
});
